import type {
  KYCQuestionDefinition,
  KYCQuestionnaireElementLayout,
} from '@anchorage/graphql/generated';
import { KYCQuestionType } from '@anchorage/graphql/generated';
import type { CustomLinkProps } from '@anchorage/utils';
import { Text } from '@latitude/text';
import type { ComponentType } from 'react';

import { Group } from '../Group';
import { type RenderTaxCertification, Question } from '../Question';

type Props = {
  question?: KYCQuestionDefinition;
  layout?: KYCQuestionnaireElementLayout;
  isFormDisabled?: boolean;
  answeredOptions?: Record<string, string>;
  CustomLink?: ComponentType<CustomLinkProps>;
  isBackoffice?: boolean;
  allQuestions?: KYCQuestionDefinition[];
  trackFn?: (questionId: string) => void;
  showTriggered?: boolean;
  formID?: string;
  renderTaxCertification?: RenderTaxCertification;
};

function QuestionWrapper({
  question,
  layout,
  isFormDisabled = false,
  answeredOptions,
  CustomLink,
  isBackoffice = false,
  allQuestions,
  trackFn = () => {},
  showTriggered = false,
  formID,
  renderTaxCertification,
}: Props) {
  if (!question) {
    return (
      <Text color="danger" className="mt-spacing-sys-spacing-24">
        Error reading the questionnaire
      </Text>
    );
  }

  return (
    <>
      {question.type === KYCQuestionType.GROUP ? (
        <Group
          key={question.id}
          question={question}
          layout={layout}
          isDisabled={isFormDisabled || question.readOnly}
          answeredOptions={answeredOptions}
          CustomLink={CustomLink}
          trackFn={trackFn}
          showTriggered={showTriggered}
        />
      ) : (
        <Question
          key={question.id}
          question={question}
          isDisabled={isFormDisabled}
          answeredOptions={answeredOptions}
          CustomLink={CustomLink}
          isBackoffice={isBackoffice}
          layout={layout}
          allQuestions={allQuestions}
          trackFn={trackFn}
          showTriggered={showTriggered}
          formID={formID}
          renderTaxCertification={renderTaxCertification}
        />
      )}
    </>
  );
}

export { QuestionWrapper };
